import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface ICreateInvoicesFromItemsRequest extends IBaseRequest {
  FOLDERS?: Record[];
  PROJECTS?: Record[];
  ACTIVITIES?: Record[];
  ITEMS?: Record[];
  DOCUMENTTYPE?: string;
}

export interface Record {
  id: string;
}

export class CreateInvoicesFromItemsRequest
  extends BaseRequest
  implements ICreateInvoicesFromItemsRequest
{
  FOLDERS?: Record[];
  PROJECTS?: Record[];
  ACTIVITIES?: Record[];
  ITEMS?: Record[];
  DOCUMENTTYPE?: string;
  SOURCETYPE?: string;

  constructor(server: string, session: string, otherOptions: any) {
    console.log("otherOptions", otherOptions);
    super(server, session);
    this.FOLDERS = otherOptions.FOLDERS;
    this.PROJECTS = otherOptions.PROJECTS;
    this.ACTIVITIES = otherOptions.ACTIVITIES;
    this.ITEMS = otherOptions.ITEMS;
    this.DOCUMENTTYPE = otherOptions.DOCUMENTTYPE;
    this.SOURCETYPE = otherOptions.SOURCETYPE;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNodeArray(
      this.FOLDERS,
      (record) => `<RECORD><id>${record.id}</id></RECORD>`,
      "FOLDERS",
    );
    parameters += this.makeNodeArray(
      this.PROJECTS,
      (record) => `<RECORD><id>${record.id}</id></RECORD>`,
      "PROJECTS",
    );
    parameters += this.makeNodeArray(
      this.ACTIVITIES,
      (record) => `<RECORD><id>${record.id}</id></RECORD>`,
      "ACTIVITIES",
    );
    parameters += this.makeNodeArray(
      this.ITEMS,
      (record) => `<RECORD><id>${record.id}</id></RECORD>`,
      "ITEMS",
    );
    parameters += this.makeNode(this.DOCUMENTTYPE || "", "documentType");
    parameters += this.makeNode(this.SOURCETYPE || "", "sourceType");
    return super.wrapperXml("CreateInvoicesFromItems", parameters);
  }
}
